import styled from 'styled-components';
import { commonImage } from 'constants/images';

export const StyledBasicImagebox = styled.div`
  margin-bottom: 20px;

  > span {
    font-weight: 600;
    margin-bottom: 4px;
    display: inline-block;
  }

  .imgWrapper {
    display: block;
    position: relative;
    width: ${(props) => props.width && props.width};
    height: ${(props) => (props.height ? props.height : '380px')};
    border-radius: 6px;
    border: 1px solid #dadada;
    background-color: var(--color-off-white);
    overflow: hidden;

    img {
      width: 100%;
      height: inherit;
      object-fit: contain;
    }

    .selectImage {
      position: absolute;
      right: 15px;
      bottom: 18px;
      width: 40px;
      height: 40px;
      padding: 0;
      margin: 0;
      min-width: unset;
      border-radius: 100%;
      background-color: var(--color-primary-blue);

      &::before {
        content: '';
        width: 28px;
        height: 28px;
        background-image: url(${commonImage.camera});
      }
    }
  }
`;
